<template>
	<div>
		<template v-if="roleRules.ASSESSMENTS_FLG === 'Y'">
			<template v-if="assessmentTypes.length > 0">
				<template v-for="(assessmentType, typeIdx) in assessmentTypes">
					<section v-if="hasScores(assessmentType)"
										:key="`type-${typeIdx}`"
										class="text-center">
						<h2>
							{{ assessmentType.ASSESSMENT_SUITE_NAME }}
						</h2>
						<div class="table-responsive">
							<table-editable-list :columns="columns"
																		:show-select="false"
																		:show-actions="false">
								<template slot="data-row">
									<template v-for="(type, idx) in assessmentType.ASSESSMENT_TYPES">
										<tr :key="`assessmentScores_${type.ASSESSMENT_TYPE_RID}_${typeIdx}_${idx}`">
											<td :colspan="columns.length">
												<strong>{{ type.ASSESSMENT_NAME }}</strong>
											</td>
										</tr>

										<template v-for="(test, index) in type.ASSESSMENT_TESTS">
											<table-list-row :key="`score_${typeIdx}_${idx}_${index}`"
												:columns="columns"
												:rowdata="{
													'ASSESSMENT_INSTANCE_NAME': test.ASSESSMENT_INSTANCE_NAME, 
													'GRADE_LEVEL': test.SCORE.GRADE_LEVEL, 
													'ASSESSMENT_DATE': formatDateTimeString(test.ASSESSMENT_DATE), 
													'OVERALL_SCORE': test.SCORE.OVERALL_SCORE, 
													'OVERALL_PROFICIENCY': !!test.SCORE && !!test.SCORE.PROFICIENCY_DESC && test.SCORE.PROFICIENCY_DESC.toString().length > 0 ? test.SCORE.PROFICIENCY_DESC : test.SCORE.OVERALL_PROFICIENCY, 
													'OVERALL_SCORE_ALPHA':test.SCORE.OVERALL_SCORE_ALPHA, 
													'IS_PROFICIENT_FLG': test.SCORE.IS_PROFICIENT_FLG, 
													'LINK': `/assessment-scores/${type.ASSESSMENT_TYPE_RID}/assessment/${test.ASSESSMENT_RID}`
													}"
												:rowIndex="index"
												:useAnchor="false"
												:showActions="false">
											</table-list-row>
										</template> 
									</template>
								</template>
							</table-editable-list>
						</div>
					</section>
				</template>
			</template>
			<template v-else>
				<div class="col-xs-12 alert alert-info">
					{{ $t('MAIN_CONTENT.AssessmentScores.noAssessmentsMessage') }}
				</div>
			</template>
		</template>
	</div>
</template>

<script>
	import Assessments from '../api/Assessments.js';
	import { mapGetters } from 'vuex';

	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';

	export default {
		data() {
			return {
				assessmentTypes: []
			}
		},
		computed: {
			...mapGetters(['selectedStudent', 'roleRules', 'role']),
			columns() {
				let col = [];
				if(this.roleRules.ASSESSMENTS_DETAILS_FLG === 'Y') {
					col = [
						{
							heading: this.$t( 'MAIN_CONTENT.AssessmentScores.assessment' ),
							key: 'ASSESSMENT_INSTANCE_NAME',
							customCol: 'assessment',
							type: 'link',
							link: 'LINK'
						},
						{
							heading: this.$t( 'MAIN_CONTENT.AssessmentScores.grade' ),
							key: 'GRADE_LEVEL',
							customCol: 'grade'
						},
						{
							heading: this.$t( 'MAIN_CONTENT.AssessmentScores.date' ),
							key: 'ASSESSMENT_DATE',
							customCol: 'date'
						},
						{
							heading: this.$t( 'MAIN_CONTENT.AssessmentScores.score' ),
							key: 'OVERALL_SCORE',
							customCol: 'score'
						},
						{
							heading: this.$t( 'MAIN_CONTENT.AssessmentScores.proficiency' ),
							key: 'OVERALL_PROFICIENCY',
							customCol: 'proficiency'
						},
						{
							heading: this.$t( 'MAIN_CONTENT.AssessmentScores.proficient' ),
							key: 'IS_PROFICIENT_FLG',
							customCol: 'proficient'
						}
					];
				} else {
					col = [
						{
							heading: this.$t( 'MAIN_CONTENT.AssessmentScores.assessment' ),
							key: 'ASSESSMENT_INSTANCE_NAME',
							customCol: 'assessment'
						},
						{
							heading: this.$t( 'MAIN_CONTENT.AssessmentScores.grade' ),
							key: 'GRADE_LEVEL',
							customCol: 'grade'
						},
						{
							heading: this.$t( 'MAIN_CONTENT.AssessmentScores.date' ),
							key: 'ASSESSMENT_DATE',
							customCol: 'date'
						},
						{
							heading: this.$t( 'MAIN_CONTENT.AssessmentScores.score' ),
							key: 'OVERALL_SCORE',
							customCol: 'score'
						},
						{
							heading: this.$t( 'MAIN_CONTENT.AssessmentScores.proficiency' ),
							key: 'OVERALL_PROFICIENCY',
							customCol: 'proficiency'
						},
						{
							heading: this.$t( 'MAIN_CONTENT.AssessmentScores.proficient' ),
							key: 'IS_PROFICIENT_FLG',
							customCol: 'proficient'
						}
					];
				}

				return col;
			}
		},
		components: {
			TableEditableList,
			TableListRow
		},
		methods: {
			loadAssessmentScores() {
				const self = this;

				let assessment = new Assessments({
					route: 'assessments',
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = assessment.get();

				promise.then(response => {
					self.$set(self, 'assessmentTypes', response.data.data);
				})
				.catch(error => {
					console.log(error);
				});
			},
			hasScores(assessment) {
				let hasScores = false;

				for(let t in assessment.ASSESSMENT_TYPES) {
					let type = assessment.ASSESSMENT_TYPES[t];

					for(let a in type.ASSESSMENT_TESTS) {
						let test = type.ASSESSMENT_TESTS[a];

						if(Object.keys(test.SCORE).length > 0) {
							hasScores = true;
						}
					}
				}

				return hasScores;
			},
			formatDateTimeString(dateTime) {
				return this.$options.filters.date(dateTime);
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'align-center');
			this.$store.commit('setTitle', 'MAIN_CONTENT.AssessmentScores.sideMenuAssessmentScoresLink');
			this.$store.commit('setUseHeader', true);

			if(this.roleRules.ASSESSMENTS_FLG === 'Y') {
				this.loadAssessmentScores();
			} else {
				this.$router.push({ name: 'HomePage' });
			}
		}
	}
</script>
